'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Suggestions;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function Suggestions(props) {
  var resultsTemplate = props.results.map(function (val, i) {
    return props.resultsTemplate(val, i, props.selectedIndex);
  });
  return _react2["default"].createElement('div', {
    className: 'ac-suggestions-wrapper'
  }, resultsTemplate);
}

Suggestions.defaultResultsTemplate = function (val, i, selectedIndex) {
  var className = (0, _classnames2["default"])('ac-suggestion', {
    'ac-suggestion-active': i === selectedIndex
  });
  return _react2["default"].createElement('div', {
    className: className,
    'data-index': i,
    key: i
  }, val.title);
};

Suggestions.propTypes = {
  results: _react.PropTypes.array.isRequired,
  resultsTemplate: _react.PropTypes.func,
  selectedIndex: _react.PropTypes.number
};